import React, {Fragment} from "react";
import {Divider, Button, Typography, Grid} from "@mui/material";
import {useStyles} from './styles'
import { Add, Download } from '@mui/icons-material';
import CountDown from "count-down-react";
import "./styles.css";

const CoundownRenderer = ({ days, hours, minutes, seconds }) => {
  return (
    <div className="container">
      <ul>
        <li> <span id="days">{days}</span>Días </li>
        <li> <span id="hours">{hours}</span>Horas </li>
        <li> <span id="minutes">{minutes}</span>Minutos </li>
        <li> <span id="seconds">{seconds}</span>Segundos </li>
      </ul>
    </div>
  );
}

function TituloConIcono(props) {
  const classes = useStyles(props);
  // const date1 = Date.now() + 26 * 60 * 60 * 1000;
  const date1 = new Date("01-15-2023 23:59:59");
  return (
    <Fragment>
      <Grid container justifyContent={"space-around"} alignItems="center" className={classes.contenedor}>
        {props.mostrarTiempo && (
          <Grid item xs={12} md={4}>
            <Grid container justifyContent={"center"} alignItems="center" flexDirection={"column"}>

              <Typography variant="p" className={classes.texto}>Fecha limite de ingreso: 15-01-2023 23:59:59</Typography>
              <Typography variant="p" className={classes.texto}>Tiempo restante para ingreso de datos</Typography>
              <Grid container justifyContent={"space-around"} alignItems="center">
                <CountDown date={date1} renderer={CoundownRenderer} />
              </Grid>
            </Grid>
          </Grid>
        )}
        <Grid item xs={12} md={4}>
          <Grid container justifyContent={"center"} alignItems="center" flexDirection="column">
            {props.showIcon && (
              <img className={classes.icon} src={`/menu/${props.icon ? props.icon : "registro_escritos"}.png`} alt="Icon Formulario"/>
            )}

            <h1 className={classes.tituloPrincipal}>{props.title}</h1>
            {props.showButton && (
              <div className={classes.container}>
                <Button variant="contained" color="primary"  onClick={undefined}>
                    <Add  />
                    {props.titleButton}
                </Button>
              </div>
            )}
          </Grid>
        </Grid>
        {props.mostrarBotones && (
          <Grid item xs={12} md={4}>
            <Grid container justifyContent={"center"} alignItems="center" >
              <Button className={classes.boton} variant="contained" color="primary"  onClick={props.handleClickButton1}>
                  <Download  />
                  {props.titleButton1}
              </Button>
              {props.handleClickButton2 && (
                <Button className={classes.boton} variant="contained" color="primary"  onClick={props.handleClickButton2}>
                    <Download  />
                    {props.titleButton2}
                </Button>
              )}
            </Grid>
          </Grid>
        )}

      </Grid>
      {props.showDivider && (
        <Divider  className={classes.divider}/>
      )}
    </Fragment>
  );
}

TituloConIcono.defaultProps = {
  showIcon: true,
  showButton: false,
  titleButton: "",
  showDivider: true,
  mostrarBotones: true,
  mostrarTiempo: false
}

export default TituloConIcono;
